import "./Checkbox.css";

import Error from "./Error";

interface CheckboxProps {
  id: string;
  label: React.ReactNode;
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
  errors?: { message: string; id: string }[];
}

const Checkbox: React.FC<CheckboxProps> = (props) => {
  const { id, label, checked, onChange, required, errors } = props;

  return (
    <div className="Checkbox">
      <input id={id} type="checkbox" onChange={onChange} checked={checked} />
      <label htmlFor={id}>
        {label}
        {required && ` *`}
      </label>
      {errors && errors.length > 0 && (
        <div className="Checkbox__errorContainer">
          {errors.map((error) => (
            <Error key={error.id}>{error.message}</Error>
          ))}
        </div>
      )}
    </div>
  );
};

export default Checkbox;
